import { cropFont } from '@ps/api/editor/font'
import { fetchFont } from '@ps/bridge/resource/font'
import qc from 'qc'

// 默认字体不需要去请求字体裁切接口
export const defaultFont = 'Arial'
// 文字中需要横竖屏区分的属性
export const styleAttrsNeedToSeparate = ['fontSize']
const defaultFontFamily = 0

export function isItalic(node: qc.UIText): boolean {
  // @ts-ignore
  if (node.phaser && node.phaser.children && node.phaser.children.length > 0 && typeof node.phaser.children[0].fontStyle === 'string') {
    // @ts-ignore
    return node.phaser.children[0].fontStyle === 'italic'
  }
  return false
}

// 设定斜体部分后续可能需要用到，这里需要处理qc的bug，就是在节点的enableGlow===true的时候，斜体设置是不生效的，必须先把enableGlow设置为false，然后才能设置，后面还需要还原enableGlow，以及让italic数据再设置一次
export function setItalic(node: qc.UIText, italicValue: boolean): void {
  function _setItalic(node: qc.UIText, italicValue: boolean) {
    // @ts-ignore
    if (node.phaser && node.phaser.children && node.phaser.children.length > 0 && typeof node.phaser.children[0].fontStyle === 'string') {
      // @ts-ignore
      node.phaser.children[0].fontStyle = italicValue ? 'italic' : 'normal'
    }
  }
  const enableGlow = node['enableGlow']
  node['enableGlow'] = false
  _setItalic(node, italicValue)
  node['enableGlow'] = enableGlow
  if (enableGlow === true) {
    _setItalic(node, italicValue)
  }
}

export function setEnableGlow(node: qc.UIText, enableGlowValue: boolean): void {
  const italicValue = isItalic(node)
  node['enableGlow'] = enableGlowValue
  const enableGlow = node['enableGlow']
  if (enableGlow === true) {
    node['enableGlow'] = false
    setItalic(node, italicValue)
    node['enableGlow'] = enableGlow
    setItalic(node, italicValue)
  } else {
    setItalic(node, italicValue)
  }
}

export function setEnableShadowAfterSetFont(node: qc.UIText): void {
  // 一些包设置完字体后，阴影丢失（主要是自研模板，引擎层面的问题，不可能针对每个包去修改，所以在这里兼容）
  // 重新设置 enableShadow，如果不重新设置阴影会失效
  // eslint-disable-next-line no-self-assign
  node.enableShadow = node.enableShadow
}

/**
 * 读取字体，如果字体不符合要求，则返回默认字体
 * @param fontName
 * @param text 文本值
 * @param fontList 字体列表
 * @param pid
 */
export async function getFont({ fontName, text, fontList, pid }: {
  fontName: string;
  text: string;
  fontList: any;
  pid: number;
}): Promise<string> {
  // 如果设置得字体不在字体列表内，则不需要去加载，直接设置字体为空即可
  if (fontList.every((font: any) => font.value !== fontName)) {
    if (fontName === '') {
      console.log('设置的字体为空，使用默认字体')
    } else {
      console.log('无法在字体列表中找到该字体，使用默认字体')
    }
    return defaultFont
  }

  if (!text || fontName === defaultFont) {
    return defaultFont
  }

  const res = await cropFont({
    text: text,
    font: fontName,
    pid
  })
  await fetchFont({
    name: fontName,
    url: (res as any).data.base64
  })
  return fontName
}

/**
 * 设置字体
 * @param nodes 要修改字体的节点
 * @param fontName 新字体名字
 */
export function setFont({ node, fontName }: {
  node: qc.UIText;
  fontName: string;
}): void {
  // 使用 document.Font 字体时，qc 需要的 fontFamily 类型是 qc.UIText.SYSTEMFONT = 0
  node.fontFamily = defaultFontFamily
  node.font = fontName || defaultFont
  setEnableShadowAfterSetFont(node)
}

export function setText({ node, text }: {
  node: qc.UIText;
  text: string;
}): void {
  node.text = text
  setFont({
    node,
    fontName: node.font as string
  })
}
